import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from 'vue-auto-routing'
import store from '../store/index'
import { createRouterLayout } from 'vue-router-layout'

import Auth from '@/firebase/auth'
const auth = new Auth()

Vue.use(VueRouter)

const RouterLayout = createRouterLayout(layout => {
  return import(`@/components/layouts/${layout}.vue`)
})

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: RouterLayout,
      children: routes
    },
  ],
})

router.beforeEach( async (to, from, next) => {
  try {
    if (!to.meta.authFree) await auth.getUser()
    return next()
  } catch {
    next({
      path: '/signin',
      query: { redirect: to.fullPath }
    })
  }
})

export default router
